import { priceBookEntryIdFormat } from "@redotech/redo-ids-cockroach";
import {
  CurrencySchema,
  PriceBookEntrySchema,
} from "@redotech/redo-model/price-book/price-book";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Updates the editable fields (price, currency, kind) of an existing price book
 * entry. The product is locked and cannot be changed.
 */
export const updatePriceBookEntry = unaryRpc({
  name: "updatePriceBookEntry" as const,
  input: z.object({
    entryId: priceBookEntryIdFormat.schema,
    fixedPrice: z.bigint().nullable().optional(),
    currency: CurrencySchema.nullable().optional(),
    kind: z.string().optional(),
  }),
  output: z.object({ entry: PriceBookEntrySchema }),
});
